'use strict';

/**
 * 判断是否是null或undefined
 * @param {any} it 被判断的值
 * @returns {boolean}
 */
module.exports = function(it) {
  return it === null || it === undefined;
};
